export default "__VITE_ASSET__Dok78V7q__"